// noinspection JSUnusedGlobalSymbols

/**
 * This file was generated by the GraphQL Code Generator.
 * DO NOT EDIT.
 * @source: graphql-codegen/codegen.yml
 */

/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /**
   * The `Date` scalar type represents a date. The Date appears in a JSON
   * response as an ISO8601 formatted string, without a time component.
   */
  Date: { input: any; output: any };
  /**
   * The `DateTime` scalar type represents a date and time in the UTC
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string, including UTC timezone ("Z"). The parsed date and time string will
   * be converted to UTC if there is an offset.
   */
  DateTime: { input: any; output: any };
};

export type AchEvent = {
  achRequestId?: Maybe<Scalars['ID']['output']>;
  authCode?: Maybe<Scalars['String']['output']>;
  avsCode?: Maybe<Scalars['String']['output']>;
  batchNumber?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  finalStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AchRequest = {
  achEvents?: Maybe<Array<Maybe<AchEvent>>>;
  achType?: Maybe<Scalars['String']['output']>;
  amountCents?: Maybe<Scalars['Int']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  loan?: Maybe<Loan>;
  returnCode?: Maybe<Scalars['String']['output']>;
  returnInitiatedAt?: Maybe<Scalars['DateTime']['output']>;
  returnProcessedAt?: Maybe<Scalars['DateTime']['output']>;
  settledAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export enum AchRequestStatus {
  AwaitingPartnerFunding = 'AWAITING_PARTNER_FUNDING',
  DepositRequested = 'DEPOSIT_REQUESTED',
  Failed = 'FAILED',
  HoldPlaced = 'HOLD_PLACED',
  Initiated = 'INITIATED',
  Processing = 'PROCESSING',
  ReturnInitiated = 'RETURN_INITIATED',
  ReturnProcessed = 'RETURN_PROCESSED',
  Scheduled = 'SCHEDULED',
  Settled = 'SETTLED',
  SettledFail = 'SETTLED_FAIL',
  TransferInitiated = 'TRANSFER_INITIATED',
}

export enum AchRequestType {
  Drawdown = 'DRAWDOWN',
  Repayment = 'REPAYMENT',
}

export type Address = {
  addressFirstLine?: Maybe<Scalars['String']['output']>;
  addressSecondLine?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isBilling?: Maybe<Scalars['Boolean']['output']>;
  isConfirmed?: Maybe<Scalars['Boolean']['output']>;
  isDebitPayment?: Maybe<Scalars['Boolean']['output']>;
  isPoBox?: Maybe<Scalars['Boolean']['output']>;
  isShipping?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AutoPaySettings = {
  daysBeforePayment?: Maybe<Scalars['Int']['output']>;
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  loan?: Maybe<Loan>;
  paymentType?: Maybe<Scalars['String']['output']>;
  plaidAccountId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export type Card = {
  active?: Maybe<Scalars['Boolean']['output']>;
  blockedReason?: Maybe<Scalars['String']['output']>;
  dateOpened?: Maybe<Scalars['DateTime']['output']>;
  expDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  lastFour?: Maybe<Scalars['String']['output']>;
  loan?: Maybe<Loan>;
  physicalActivatedAt?: Maybe<Scalars['DateTime']['output']>;
  processor?: Maybe<CardProcessor>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CardStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export enum CardProcessor {
  I2C = 'I2C',
  Lithic = 'LITHIC',
}

export enum CardStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Closed = 'CLOSED',
  Lost = 'LOST',
  NotActivated = 'NOT_ACTIVATED',
  Replaced = 'REPLACED',
  Stolen = 'STOLEN',
}

export type CreditUtilizationData = {
  availableAmount: Scalars['String']['output'];
  balance: Scalars['String']['output'];
  limit: Scalars['String']['output'];
  remaining: Scalars['String']['output'];
  spent: Scalars['String']['output'];
};

export type DeviceToken = {
  appVersion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceModel?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<DeviceType>;
  id?: Maybe<Scalars['ID']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  osVersion?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum DeviceType {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB',
}

export type ListAchRequestsResult = {
  achRequests?: Maybe<Array<AchRequest>>;
  pagination: PaginationDetails;
};

export type ListCardsResult = {
  cards?: Maybe<Array<Card>>;
  pagination: PaginationDetails;
};

export type ListDevicesResult = {
  devices?: Maybe<Array<DeviceToken>>;
  pagination: PaginationDetails;
};

export type ListLoansResult = {
  loans?: Maybe<Array<Loan>>;
  pagination: PaginationDetails;
};

export type ListUsersResult = {
  pagination: PaginationDetails;
  users?: Maybe<Array<User>>;
};

export type Loan = {
  achRequests: Array<AchRequest>;
  aprMargin?: Maybe<Scalars['String']['output']>;
  autoPaySettings?: Maybe<AutoPaySettings>;
  cards: Array<Card>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  creditLimit?: Maybe<Scalars['Int']['output']>;
  currentApr?: Maybe<Scalars['String']['output']>;
  currentPrimeRate?: Maybe<Scalars['String']['output']>;
  dateOfLastActivity?: Maybe<Scalars['Date']['output']>;
  daysDelinquent?: Maybe<Scalars['Int']['output']>;
  delinquentSince?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  initialApr?: Maybe<Scalars['String']['output']>;
  initialBalance?: Maybe<Scalars['Int']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  isDelinquent?: Maybe<Scalars['Boolean']['output']>;
  isVariableApr?: Maybe<Scalars['Boolean']['output']>;
  originationDate?: Maybe<Scalars['Date']['output']>;
  partnerAccountNumber?: Maybe<Scalars['String']['output']>;
  program?: Maybe<Program>;
  programId?: Maybe<Scalars['ID']['output']>;
  promoEndDate?: Maybe<Scalars['Date']['output']>;
  propertyState?: Maybe<Scalars['String']['output']>;
  statements: Array<Statement>;
  status?: Maybe<LoanStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users: Array<User>;
};

export type LoanMember = {
  firstName?: Maybe<Scalars['String']['output']>;
  joinedAt: Scalars['DateTime']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export enum LoanStatus {
  Boarded = 'BOARDED',
  Closed = 'CLOSED',
  Delinquent = 'DELINQUENT',
}

export type LoanWithoutServicingData = {
  id: Scalars['ID']['output'];
  members: Array<LoanMember>;
  originationDate?: Maybe<Scalars['Date']['output']>;
  partnerAccountNumber?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type MerchantDetails = {
  city?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type PaginationDetails = {
  hasNextPage: Scalars['Boolean']['output'];
  pageNumber: Scalars['Int']['output'];
  resultsPerPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
  totalRecords: Scalars['Int']['output'];
};

export type Program = {
  active?: Maybe<Scalars['Boolean']['output']>;
  firstLateFeeAmount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  lateFeeGracePeriodDays?: Maybe<Scalars['Int']['output']>;
  maxApr?: Maybe<Scalars['String']['output']>;
  minApr?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  paymentDueDateGracePeriodDays?: Maybe<Scalars['Int']['output']>;
  statementCloseDay?: Maybe<Scalars['Int']['output']>;
  statementGenerateDay?: Maybe<Scalars['Int']['output']>;
  subsequentLateFeeAmount?: Maybe<Scalars['Int']['output']>;
  targetInterestRate?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RootQueryType = {
  creditUtilization?: Maybe<CreditUtilizationData>;
  currentUser?: Maybe<User>;
  listCards?: Maybe<ListCardsResult>;
  listDevices?: Maybe<ListDevicesResult>;
  listLoans?: Maybe<ListLoansResult>;
  listUsers?: Maybe<ListUsersResult>;
  loan?: Maybe<Loan>;
  loanAchRequests?: Maybe<ListAchRequestsResult>;
  loanAutoPaySettings?: Maybe<AutoPaySettings>;
  loanStatements: Array<Statement>;
  loanTransactions?: Maybe<UserTransactionsList>;
  loansWithoutServicingData: Array<LoanWithoutServicingData>;
  programs: Array<Program>;
};

export type RootQueryTypeCreditUtilizationArgs = {
  loanId: Scalars['ID']['input'];
};

export type RootQueryTypeListCardsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  idSearch?: InputMaybe<Scalars['String']['input']>;
  idSortDirection?: InputMaybe<SortDirection>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  programId?: InputMaybe<Scalars['ID']['input']>;
  referenceIdSearch?: InputMaybe<Scalars['String']['input']>;
  referenceIdSortDirection?: InputMaybe<SortDirection>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  statusSelections?: InputMaybe<Array<InputMaybe<CardStatus>>>;
  statusSortDirection?: InputMaybe<SortDirection>;
  to?: InputMaybe<Scalars['Date']['input']>;
  userEmailSearch?: InputMaybe<Scalars['String']['input']>;
  userEmailSortDirection?: InputMaybe<SortDirection>;
  userFirstNameSearch?: InputMaybe<Scalars['String']['input']>;
  userFirstNameSortDirection?: InputMaybe<SortDirection>;
  userIsFriendsAndFam?: InputMaybe<Scalars['Boolean']['input']>;
  userLastNameSearch?: InputMaybe<Scalars['String']['input']>;
  userLastNameSortDirection?: InputMaybe<SortDirection>;
};

export type RootQueryTypeListDevicesArgs = {
  deviceTypeSelections?: InputMaybe<Array<InputMaybe<DeviceType>>>;
  deviceTypeSortDirection?: InputMaybe<SortDirection>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  programId?: InputMaybe<Scalars['ID']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  userEmailSearch?: InputMaybe<Scalars['String']['input']>;
  userEmailSortDirection?: InputMaybe<SortDirection>;
  userFirstNameSearch?: InputMaybe<Scalars['String']['input']>;
  userFirstNameSortDirection?: InputMaybe<SortDirection>;
  userIdSearch?: InputMaybe<Scalars['String']['input']>;
  userIdSortDirection?: InputMaybe<SortDirection>;
  userLastNameSearch?: InputMaybe<Scalars['String']['input']>;
  userLastNameSortDirection?: InputMaybe<SortDirection>;
};

export type RootQueryTypeListLoansArgs = {
  borrowerSortDirection?: InputMaybe<SortDirection>;
  closedAtSortDirection?: InputMaybe<SortDirection>;
  dateOfLastActivitySortDirection?: InputMaybe<SortDirection>;
  from?: InputMaybe<Scalars['Date']['input']>;
  hasPromo?: InputMaybe<Scalars['Boolean']['input']>;
  idSearch?: InputMaybe<Scalars['String']['input']>;
  idSortDirection?: InputMaybe<SortDirection>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  originationDateSortDirection?: InputMaybe<SortDirection>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  partnerAccountNumberSearch?: InputMaybe<Scalars['String']['input']>;
  partnerAccountNumberSortDirection?: InputMaybe<SortDirection>;
  programId?: InputMaybe<Scalars['ID']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  statusSelections?: InputMaybe<Array<InputMaybe<LoanStatus>>>;
  statusSortDirection?: InputMaybe<SortDirection>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type RootQueryTypeListUsersArgs = {
  dobSearch?: InputMaybe<Scalars['String']['input']>;
  dobSortDirection?: InputMaybe<SortDirection>;
  firstNameSearch?: InputMaybe<Scalars['String']['input']>;
  firstNameSortDirection?: InputMaybe<SortDirection>;
  from?: InputMaybe<Scalars['Date']['input']>;
  idSearch?: InputMaybe<Scalars['String']['input']>;
  idSortDirection?: InputMaybe<SortDirection>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  isFriendsAndFam?: InputMaybe<Scalars['Boolean']['input']>;
  lastNameSearch?: InputMaybe<Scalars['String']['input']>;
  lastNameSortDirection?: InputMaybe<SortDirection>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  phoneSearch?: InputMaybe<Scalars['String']['input']>;
  phoneSortDirection?: InputMaybe<SortDirection>;
  programId?: InputMaybe<Scalars['ID']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type RootQueryTypeLoanArgs = {
  id: Scalars['ID']['input'];
};

export type RootQueryTypeLoanAchRequestsArgs = {
  achTypeSelections?: InputMaybe<Array<InputMaybe<AchRequestType>>>;
  achTypeSortDirection?: InputMaybe<SortDirection>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  loanId: Scalars['ID']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  statusSelections?: InputMaybe<Array<InputMaybe<AchRequestStatus>>>;
  statusSortDirection?: InputMaybe<SortDirection>;
};

export type RootQueryTypeLoanAutoPaySettingsArgs = {
  loanId: Scalars['ID']['input'];
};

export type RootQueryTypeLoanStatementsArgs = {
  loanId: Scalars['ID']['input'];
};

export type RootQueryTypeLoanTransactionsArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  loanId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<SortDirection>;
  to?: InputMaybe<Scalars['Date']['input']>;
  viewMode?: InputMaybe<TransactionViewMode>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type Statement = {
  autopayProcessedAt?: Maybe<Scalars['String']['output']>;
  /** Average daily balance subject to interest rate for the billing period — the base (per the program's accrual_base setting) the periodic rate was applied to, in cents. */
  averageDailyBalance?: Maybe<Scalars['Int']['output']>;
  billingPeriodEnd: Scalars['String']['output'];
  billingPeriodStart: Scalars['String']['output'];
  cashAdvance: Scalars['String']['output'];
  closingBalance?: Maybe<Scalars['String']['output']>;
  creditLimit: Scalars['String']['output'];
  creditLimitAvailable: Scalars['String']['output'];
  drawdownBalanceAtPeriodEnd?: Maybe<Scalars['Int']['output']>;
  dueDate: Scalars['String']['output'];
  dueDateProcessedAt?: Maybe<Scalars['String']['output']>;
  feeBalanceAtPeriodEnd?: Maybe<Scalars['Int']['output']>;
  feesCharged: Scalars['String']['output'];
  graceActive?: Maybe<Scalars['Boolean']['output']>;
  graceSavings?: Maybe<Scalars['Int']['output']>;
  hasPdf?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['String']['output'];
  interestApplied?: Maybe<Scalars['String']['output']>;
  interestBalanceAtPeriodEnd?: Maybe<Scalars['Int']['output']>;
  interestCharged: Scalars['String']['output'];
  lateFeeApplied?: Maybe<Scalars['String']['output']>;
  lateFeeEligibleOn?: Maybe<Scalars['String']['output']>;
  lateFeeProcessedAt?: Maybe<Scalars['String']['output']>;
  loan?: Maybe<Loan>;
  minimumPaymentDue: Scalars['String']['output'];
  newBalance: Scalars['String']['output'];
  newPurchaseBalanceAtPeriodEnd?: Maybe<Scalars['Int']['output']>;
  otherCredits: Scalars['String']['output'];
  pdfFilename?: Maybe<Scalars['String']['output']>;
  pdfGeneratedAt?: Maybe<Scalars['String']['output']>;
  previousBalance: Scalars['String']['output'];
  previousBalancePaidInFull?: Maybe<Scalars['Boolean']['output']>;
  purchaseBalanceAtPeriodEnd?: Maybe<Scalars['Int']['output']>;
  repaymentBalanceAtPeriodEnd?: Maybe<Scalars['Int']['output']>;
  statementDate?: Maybe<Scalars['String']['output']>;
  totalPayments: Scalars['String']['output'];
  totalPurchases: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  ytdFeesCharged: Scalars['String']['output'];
  ytdInterestCharged: Scalars['String']['output'];
};

/** View mode for transaction queries */
export enum TransactionViewMode {
  /** Client view - same as mobile app (filters internal transactions) */
  Client = 'CLIENT',
  /** Ledger view - all transactions unfiltered */
  Ledger = 'LEDGER',
}

export type User = {
  active?: Maybe<Scalars['Boolean']['output']>;
  adminProgram?: Maybe<Program>;
  billingAddress?: Maybe<Address>;
  cards?: Maybe<Array<Maybe<Card>>>;
  dob?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  isFriendsAndFam?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  loans: Array<Loan>;
  middleName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UserRole>;
  shippingAddress?: Maybe<Address>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum UserRole {
  PartnerAdmin = 'PARTNER_ADMIN',
  SupportAgent = 'SUPPORT_AGENT',
  User = 'USER',
}

export type UserTransaction = {
  amount?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  merchantDetails?: Maybe<MerchantDetails>;
  status?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
  transmissionDate?: Maybe<Scalars['String']['output']>;
};

export type UserTransactionsList = {
  transactions?: Maybe<Array<Maybe<UserTransaction>>>;
};

export type CurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentUserQuery = {
  currentUser?: {
    id?: string | null;
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    role?: UserRole | null;
  } | null;
};

export type GetLoanAutoPaySettingsQueryVariables = Exact<{
  loanId: Scalars['ID']['input'];
}>;

export type GetLoanAutoPaySettingsQuery = {
  loanAutoPaySettings?: {
    id?: string | null;
    paymentType?: string | null;
    daysBeforePayment?: number | null;
    enabled?: boolean | null;
    plaidAccountId?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
  } | null;
};

export type GetCardByIdQueryVariables = Exact<{
  cardId: Scalars['String']['input'];
}>;

export type GetCardByIdQuery = {
  listCards?: {
    cards?: Array<{
      id?: string | null;
      status?: CardStatus | null;
      active?: boolean | null;
      referenceId?: string | null;
      lastFour?: string | null;
      expDate?: string | null;
      dateOpened?: any | null;
      blockedReason?: string | null;
      physicalActivatedAt?: any | null;
      insertedAt?: any | null;
      user?: {
        id?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        isFriendsAndFam?: boolean | null;
      } | null;
      loan?: { id: string; partnerAccountNumber?: string | null } | null;
    }> | null;
  } | null;
};

export type GetCreditUtilizationQueryVariables = Exact<{
  loanId: Scalars['ID']['input'];
}>;

export type GetCreditUtilizationQuery = {
  creditUtilization?: {
    limit: string;
    balance: string;
    availableAmount: string;
    spent: string;
    remaining: string;
  } | null;
};

export type GetLoanByIdQueryVariables = Exact<{
  loanId: Scalars['ID']['input'];
}>;

export type GetLoanByIdQuery = {
  loan?: {
    id: string;
    partnerAccountNumber?: string | null;
    creditLimit?: number | null;
    initialBalance?: number | null;
    originationDate?: any | null;
    promoEndDate?: any | null;
    aprMargin?: string | null;
    initialApr?: string | null;
    currentApr?: string | null;
    currentPrimeRate?: string | null;
    isVariableApr?: boolean | null;
    status?: LoanStatus | null;
    delinquentSince?: any | null;
    daysDelinquent?: number | null;
    isDelinquent?: boolean | null;
    closedAt?: any | null;
    insertedAt?: any | null;
    programId?: string | null;
    program?: {
      id: string;
      name: string;
      targetInterestRate?: string | null;
      minApr?: string | null;
      maxApr?: string | null;
      firstLateFeeAmount?: number | null;
      subsequentLateFeeAmount?: number | null;
      paymentDueDateGracePeriodDays?: number | null;
      lateFeeGracePeriodDays?: number | null;
      statementCloseDay?: number | null;
      statementGenerateDay?: number | null;
      active?: boolean | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
    } | null;
    users: Array<{
      id?: string | null;
      firstName?: string | null;
      middleName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      dob?: string | null;
      isFriendsAndFam?: boolean | null;
      insertedAt?: any | null;
    }>;
    cards: Array<{
      id?: string | null;
      status?: CardStatus | null;
      referenceId?: string | null;
      active?: boolean | null;
      lastFour?: string | null;
      expDate?: string | null;
      physicalActivatedAt?: any | null;
      blockedReason?: string | null;
      dateOpened?: any | null;
      insertedAt?: any | null;
      user?: { id?: string | null; firstName?: string | null; lastName?: string | null } | null;
    }>;
    statements: Array<{ id: string }>;
    achRequests: Array<{ id: string }>;
  } | null;
};

export type GetLoanAchRequestsQueryVariables = Exact<{
  loanId: Scalars['ID']['input'];
  insertedAtSortDirection?: InputMaybe<SortDirection>;
}>;

export type GetLoanAchRequestsQuery = {
  loanAchRequests?: {
    achRequests?: Array<{
      id: string;
      achType?: string | null;
      amountCents?: number | null;
      status?: string | null;
      failureReason?: string | null;
      returnCode?: string | null;
      returnInitiatedAt?: any | null;
      returnProcessedAt?: any | null;
      settledAt?: any | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
    }> | null;
  } | null;
};

export type GetUserByIdQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export type GetUserByIdQuery = {
  listUsers?: {
    users?: Array<{
      id?: string | null;
      firstName?: string | null;
      middleName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      dob?: string | null;
      isFriendsAndFam?: boolean | null;
      insertedAt?: any | null;
      cards?: Array<{
        id?: string | null;
        status?: CardStatus | null;
        referenceId?: string | null;
        active?: boolean | null;
        lastFour?: string | null;
        expDate?: string | null;
        physicalActivatedAt?: any | null;
        blockedReason?: string | null;
        dateOpened?: any | null;
        insertedAt?: any | null;
      } | null> | null;
      loans: Array<{
        id: string;
        partnerAccountNumber?: string | null;
        status?: LoanStatus | null;
        isDelinquent?: boolean | null;
        program?: { id: string; name: string } | null;
      }>;
      billingAddress?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        isPoBox?: boolean | null;
      } | null;
      shippingAddress?: {
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        isPoBox?: boolean | null;
      } | null;
    }> | null;
  } | null;
};

export type GetLoanStatementsQueryVariables = Exact<{
  loanId: Scalars['ID']['input'];
}>;

export type GetLoanStatementsQuery = {
  loanStatements: Array<{
    id: string;
    billingPeriodStart: string;
    billingPeriodEnd: string;
    dueDate: string;
    previousBalance: string;
    totalPayments: string;
    otherCredits: string;
    totalPurchases: string;
    cashAdvance: string;
    interestCharged: string;
    feesCharged: string;
    newBalance: string;
    creditLimit: string;
    creditLimitAvailable: string;
    minimumPaymentDue: string;
    ytdFeesCharged: string;
    ytdInterestCharged: string;
    closingBalance?: string | null;
    interestApplied?: string | null;
    lateFeeApplied?: string | null;
    hasPdf?: boolean | null;
    purchaseBalanceAtPeriodEnd?: number | null;
    drawdownBalanceAtPeriodEnd?: number | null;
    interestBalanceAtPeriodEnd?: number | null;
    feeBalanceAtPeriodEnd?: number | null;
    repaymentBalanceAtPeriodEnd?: number | null;
    averageDailyBalance?: number | null;
    graceSavings?: number | null;
    newPurchaseBalanceAtPeriodEnd?: number | null;
    statementDate?: string | null;
    graceActive?: boolean | null;
    previousBalancePaidInFull?: boolean | null;
    lateFeeEligibleOn?: string | null;
    dueDateProcessedAt?: string | null;
    lateFeeProcessedAt?: string | null;
    autopayProcessedAt?: string | null;
    pdfGeneratedAt?: string | null;
    insertedAt: string;
    updatedAt: string;
    loan?: { id: string; partnerAccountNumber?: string | null } | null;
  }>;
};

export type GetLoanTransactionsQueryVariables = Exact<{
  loanId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  viewMode?: InputMaybe<TransactionViewMode>;
}>;

export type GetLoanTransactionsQuery = {
  loanTransactions?: {
    transactions?: Array<{
      id?: string | null;
      amount?: string | null;
      effectiveDate?: string | null;
      transmissionDate?: string | null;
      transactionType?: string | null;
      direction?: string | null;
      status?: string | null;
      merchantDetails?: {
        name?: string | null;
        displayName?: string | null;
        city?: string | null;
        region?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ListCardsQueryVariables = Exact<{
  idSortDirection?: InputMaybe<SortDirection>;
  idSearch?: InputMaybe<Scalars['String']['input']>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  statusSortDirection?: InputMaybe<SortDirection>;
  statusSelections?: InputMaybe<Array<InputMaybe<CardStatus>> | InputMaybe<CardStatus>>;
  referenceIdSortDirection?: InputMaybe<SortDirection>;
  referenceIdSearch?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  userFirstNameSortDirection?: InputMaybe<SortDirection>;
  userFirstNameSearch?: InputMaybe<Scalars['String']['input']>;
  userLastNameSortDirection?: InputMaybe<SortDirection>;
  userLastNameSearch?: InputMaybe<Scalars['String']['input']>;
  userEmailSortDirection?: InputMaybe<SortDirection>;
  userEmailSearch?: InputMaybe<Scalars['String']['input']>;
  userIsFriendsAndFam?: InputMaybe<Scalars['Boolean']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  programId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type ListCardsQuery = {
  listCards?: {
    cards?: Array<{
      id?: string | null;
      status?: CardStatus | null;
      referenceId?: string | null;
      active?: boolean | null;
      lastFour?: string | null;
      expDate?: string | null;
      physicalActivatedAt?: any | null;
      blockedReason?: string | null;
      dateOpened?: any | null;
      insertedAt?: any | null;
      user?: {
        id?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        isFriendsAndFam?: boolean | null;
      } | null;
      loan?: { id: string; program?: { id: string; name: string } | null } | null;
    }> | null;
    pagination: {
      totalRecords: number;
      resultsPerPage: number;
      pageNumber: number;
      hasNextPage: boolean;
      totalPages: number;
    };
  } | null;
};

export type ListDevicesQueryVariables = Exact<{
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  userIdSortDirection?: InputMaybe<SortDirection>;
  userIdSearch?: InputMaybe<Scalars['String']['input']>;
  userFirstNameSortDirection?: InputMaybe<SortDirection>;
  userFirstNameSearch?: InputMaybe<Scalars['String']['input']>;
  userLastNameSortDirection?: InputMaybe<SortDirection>;
  userLastNameSearch?: InputMaybe<Scalars['String']['input']>;
  userEmailSortDirection?: InputMaybe<SortDirection>;
  userEmailSearch?: InputMaybe<Scalars['String']['input']>;
  deviceTypeSortDirection?: InputMaybe<SortDirection>;
  deviceTypeSelections?: InputMaybe<Array<InputMaybe<DeviceType>> | InputMaybe<DeviceType>>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  programId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type ListDevicesQuery = {
  listDevices?: {
    devices?: Array<{
      id?: string | null;
      userId?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      osVersion?: string | null;
      appVersion?: string | null;
      lastUsedAt?: any | null;
      createdAt?: any | null;
      deletedAt?: any | null;
      user?: { id?: string | null; loans: Array<{ id: string; program?: { id: string; name: string } | null }> } | null;
    }> | null;
    pagination: {
      totalRecords: number;
      resultsPerPage: number;
      pageNumber: number;
      hasNextPage: boolean;
      totalPages: number;
    };
  } | null;
};

export type ListLoansQueryVariables = Exact<{
  idSortDirection?: InputMaybe<SortDirection>;
  idSearch?: InputMaybe<Scalars['String']['input']>;
  partnerAccountNumberSortDirection?: InputMaybe<SortDirection>;
  partnerAccountNumberSearch?: InputMaybe<Scalars['String']['input']>;
  hasPromo?: InputMaybe<Scalars['Boolean']['input']>;
  statusSortDirection?: InputMaybe<SortDirection>;
  statusSelections?: InputMaybe<Array<InputMaybe<LoanStatus>> | InputMaybe<LoanStatus>>;
  borrowerSortDirection?: InputMaybe<SortDirection>;
  closedAtSortDirection?: InputMaybe<SortDirection>;
  dateOfLastActivitySortDirection?: InputMaybe<SortDirection>;
  originationDateSortDirection?: InputMaybe<SortDirection>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  programId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type ListLoansQuery = {
  listLoans?: {
    loans?: Array<{
      id: string;
      partnerAccountNumber?: string | null;
      propertyState?: string | null;
      status?: LoanStatus | null;
      creditLimit?: number | null;
      aprMargin?: string | null;
      isDelinquent?: boolean | null;
      closedAt?: any | null;
      dateOfLastActivity?: any | null;
      originationDate?: any | null;
      users: Array<{ id?: string | null; firstName?: string | null; lastName?: string | null }>;
      program?: { id: string; name: string } | null;
    }> | null;
    pagination: {
      totalRecords: number;
      resultsPerPage: number;
      pageNumber: number;
      hasNextPage: boolean;
      totalPages: number;
    };
  } | null;
};

export type ListUsersQueryVariables = Exact<{
  idSortDirection?: InputMaybe<SortDirection>;
  idSearch?: InputMaybe<Scalars['String']['input']>;
  firstNameSortDirection?: InputMaybe<SortDirection>;
  firstNameSearch?: InputMaybe<Scalars['String']['input']>;
  lastNameSortDirection?: InputMaybe<SortDirection>;
  lastNameSearch?: InputMaybe<Scalars['String']['input']>;
  phoneSortDirection?: InputMaybe<SortDirection>;
  phoneSearch?: InputMaybe<Scalars['String']['input']>;
  dobSortDirection?: InputMaybe<SortDirection>;
  dobSearch?: InputMaybe<Scalars['String']['input']>;
  isFriendsAndFam?: InputMaybe<Scalars['Boolean']['input']>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  programId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type ListUsersQuery = {
  listUsers?: {
    users?: Array<{
      id?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
      dob?: string | null;
      isFriendsAndFam?: boolean | null;
      insertedAt?: any | null;
      loans: Array<{ id: string; program?: { id: string; name: string } | null }>;
    }> | null;
    pagination: {
      totalRecords: number;
      resultsPerPage: number;
      pageNumber: number;
      hasNextPage: boolean;
      totalPages: number;
    };
  } | null;
};

export type LoansWithoutServicingDataQueryVariables = Exact<{ [key: string]: never }>;

export type LoansWithoutServicingDataQuery = {
  loansWithoutServicingData: Array<{
    id: string;
    partnerAccountNumber?: string | null;
    originationDate?: any | null;
    status: string;
    members: Array<{ userId: string; firstName?: string | null; lastName?: string | null; joinedAt: any }>;
  }>;
};

export type ProgramsQueryVariables = Exact<{ [key: string]: never }>;

export type ProgramsQuery = { programs: Array<{ id: string; name: string }> };

export const CurrentUserDocument = /*#__PURE__*/ gql`
  query currentUser {
    currentUser {
      id
      email
      firstName
      lastName
      role
    }
  }
`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(
  baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
}
export function useCurrentUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
}
// @ts-ignore
export function useCurrentUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>,
): Apollo.UseSuspenseQueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export function useCurrentUserSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>,
): Apollo.UseSuspenseQueryResult<CurrentUserQuery | undefined, CurrentUserQueryVariables>;
export function useCurrentUserSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
}
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const GetLoanAutoPaySettingsDocument = /*#__PURE__*/ gql`
  query getLoanAutoPaySettings($loanId: ID!) {
    loanAutoPaySettings(loanId: $loanId) {
      id
      paymentType
      daysBeforePayment
      enabled
      plaidAccountId
      insertedAt
      updatedAt
    }
  }
`;

/**
 * __useGetLoanAutoPaySettingsQuery__
 *
 * To run a query within a React component, call `useGetLoanAutoPaySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanAutoPaySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanAutoPaySettingsQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useGetLoanAutoPaySettingsQuery(
  baseOptions: Apollo.QueryHookOptions<GetLoanAutoPaySettingsQuery, GetLoanAutoPaySettingsQueryVariables> &
    ({ variables: GetLoanAutoPaySettingsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLoanAutoPaySettingsQuery, GetLoanAutoPaySettingsQueryVariables>(
    GetLoanAutoPaySettingsDocument,
    options,
  );
}
export function useGetLoanAutoPaySettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLoanAutoPaySettingsQuery, GetLoanAutoPaySettingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLoanAutoPaySettingsQuery, GetLoanAutoPaySettingsQueryVariables>(
    GetLoanAutoPaySettingsDocument,
    options,
  );
}
// @ts-ignore
export function useGetLoanAutoPaySettingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetLoanAutoPaySettingsQuery, GetLoanAutoPaySettingsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanAutoPaySettingsQuery, GetLoanAutoPaySettingsQueryVariables>;
export function useGetLoanAutoPaySettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLoanAutoPaySettingsQuery, GetLoanAutoPaySettingsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanAutoPaySettingsQuery | undefined, GetLoanAutoPaySettingsQueryVariables>;
export function useGetLoanAutoPaySettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLoanAutoPaySettingsQuery, GetLoanAutoPaySettingsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLoanAutoPaySettingsQuery, GetLoanAutoPaySettingsQueryVariables>(
    GetLoanAutoPaySettingsDocument,
    options,
  );
}
export type GetLoanAutoPaySettingsQueryHookResult = ReturnType<typeof useGetLoanAutoPaySettingsQuery>;
export type GetLoanAutoPaySettingsLazyQueryHookResult = ReturnType<typeof useGetLoanAutoPaySettingsLazyQuery>;
export type GetLoanAutoPaySettingsSuspenseQueryHookResult = ReturnType<typeof useGetLoanAutoPaySettingsSuspenseQuery>;
export type GetLoanAutoPaySettingsQueryResult = Apollo.QueryResult<
  GetLoanAutoPaySettingsQuery,
  GetLoanAutoPaySettingsQueryVariables
>;
export const GetCardByIdDocument = /*#__PURE__*/ gql`
  query getCardById($cardId: String!) {
    listCards(idSearch: $cardId, resultsPerPage: 20, pageNumber: 1) {
      cards {
        id
        status
        active
        referenceId
        lastFour
        expDate
        dateOpened
        blockedReason
        physicalActivatedAt
        insertedAt
        user {
          id
          firstName
          lastName
          isFriendsAndFam
        }
        loan {
          id
          partnerAccountNumber
        }
      }
    }
  }
`;

/**
 * __useGetCardByIdQuery__
 *
 * To run a query within a React component, call `useGetCardByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardByIdQuery({
 *   variables: {
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useGetCardByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetCardByIdQuery, GetCardByIdQueryVariables> &
    ({ variables: GetCardByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCardByIdQuery, GetCardByIdQueryVariables>(GetCardByIdDocument, options);
}
export function useGetCardByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCardByIdQuery, GetCardByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCardByIdQuery, GetCardByIdQueryVariables>(GetCardByIdDocument, options);
}
// @ts-ignore
export function useGetCardByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetCardByIdQuery, GetCardByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCardByIdQuery, GetCardByIdQueryVariables>;
export function useGetCardByIdSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardByIdQuery, GetCardByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCardByIdQuery | undefined, GetCardByIdQueryVariables>;
export function useGetCardByIdSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardByIdQuery, GetCardByIdQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCardByIdQuery, GetCardByIdQueryVariables>(GetCardByIdDocument, options);
}
export type GetCardByIdQueryHookResult = ReturnType<typeof useGetCardByIdQuery>;
export type GetCardByIdLazyQueryHookResult = ReturnType<typeof useGetCardByIdLazyQuery>;
export type GetCardByIdSuspenseQueryHookResult = ReturnType<typeof useGetCardByIdSuspenseQuery>;
export type GetCardByIdQueryResult = Apollo.QueryResult<GetCardByIdQuery, GetCardByIdQueryVariables>;
export const GetCreditUtilizationDocument = /*#__PURE__*/ gql`
  query getCreditUtilization($loanId: ID!) {
    creditUtilization(loanId: $loanId) {
      limit
      balance
      availableAmount
      spent
      remaining
    }
  }
`;

/**
 * __useGetCreditUtilizationQuery__
 *
 * To run a query within a React component, call `useGetCreditUtilizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditUtilizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditUtilizationQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useGetCreditUtilizationQuery(
  baseOptions: Apollo.QueryHookOptions<GetCreditUtilizationQuery, GetCreditUtilizationQueryVariables> &
    ({ variables: GetCreditUtilizationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCreditUtilizationQuery, GetCreditUtilizationQueryVariables>(
    GetCreditUtilizationDocument,
    options,
  );
}
export function useGetCreditUtilizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCreditUtilizationQuery, GetCreditUtilizationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCreditUtilizationQuery, GetCreditUtilizationQueryVariables>(
    GetCreditUtilizationDocument,
    options,
  );
}
// @ts-ignore
export function useGetCreditUtilizationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetCreditUtilizationQuery, GetCreditUtilizationQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCreditUtilizationQuery, GetCreditUtilizationQueryVariables>;
export function useGetCreditUtilizationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCreditUtilizationQuery, GetCreditUtilizationQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCreditUtilizationQuery | undefined, GetCreditUtilizationQueryVariables>;
export function useGetCreditUtilizationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCreditUtilizationQuery, GetCreditUtilizationQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCreditUtilizationQuery, GetCreditUtilizationQueryVariables>(
    GetCreditUtilizationDocument,
    options,
  );
}
export type GetCreditUtilizationQueryHookResult = ReturnType<typeof useGetCreditUtilizationQuery>;
export type GetCreditUtilizationLazyQueryHookResult = ReturnType<typeof useGetCreditUtilizationLazyQuery>;
export type GetCreditUtilizationSuspenseQueryHookResult = ReturnType<typeof useGetCreditUtilizationSuspenseQuery>;
export type GetCreditUtilizationQueryResult = Apollo.QueryResult<
  GetCreditUtilizationQuery,
  GetCreditUtilizationQueryVariables
>;
export const GetLoanByIdDocument = /*#__PURE__*/ gql`
  query getLoanById($loanId: ID!) {
    loan(id: $loanId) {
      id
      partnerAccountNumber
      creditLimit
      initialBalance
      originationDate
      promoEndDate
      aprMargin
      initialApr
      currentApr
      currentPrimeRate
      isVariableApr
      status
      delinquentSince
      daysDelinquent
      isDelinquent
      closedAt
      insertedAt
      programId
      program {
        id
        name
        targetInterestRate
        minApr
        maxApr
        firstLateFeeAmount
        subsequentLateFeeAmount
        paymentDueDateGracePeriodDays
        lateFeeGracePeriodDays
        statementCloseDay
        statementGenerateDay
        active
        insertedAt
        updatedAt
      }
      users {
        id
        firstName
        middleName
        lastName
        email
        phone
        dob
        isFriendsAndFam
        insertedAt
      }
      cards {
        id
        status
        referenceId
        active
        lastFour
        expDate
        physicalActivatedAt
        blockedReason
        dateOpened
        insertedAt
        user {
          id
          firstName
          lastName
        }
      }
      statements {
        id
      }
      achRequests {
        id
      }
    }
  }
`;

/**
 * __useGetLoanByIdQuery__
 *
 * To run a query within a React component, call `useGetLoanByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanByIdQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useGetLoanByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetLoanByIdQuery, GetLoanByIdQueryVariables> &
    ({ variables: GetLoanByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLoanByIdQuery, GetLoanByIdQueryVariables>(GetLoanByIdDocument, options);
}
export function useGetLoanByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLoanByIdQuery, GetLoanByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLoanByIdQuery, GetLoanByIdQueryVariables>(GetLoanByIdDocument, options);
}
// @ts-ignore
export function useGetLoanByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetLoanByIdQuery, GetLoanByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanByIdQuery, GetLoanByIdQueryVariables>;
export function useGetLoanByIdSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLoanByIdQuery, GetLoanByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanByIdQuery | undefined, GetLoanByIdQueryVariables>;
export function useGetLoanByIdSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLoanByIdQuery, GetLoanByIdQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLoanByIdQuery, GetLoanByIdQueryVariables>(GetLoanByIdDocument, options);
}
export type GetLoanByIdQueryHookResult = ReturnType<typeof useGetLoanByIdQuery>;
export type GetLoanByIdLazyQueryHookResult = ReturnType<typeof useGetLoanByIdLazyQuery>;
export type GetLoanByIdSuspenseQueryHookResult = ReturnType<typeof useGetLoanByIdSuspenseQuery>;
export type GetLoanByIdQueryResult = Apollo.QueryResult<GetLoanByIdQuery, GetLoanByIdQueryVariables>;
export const GetLoanAchRequestsDocument = /*#__PURE__*/ gql`
  query getLoanAchRequests($loanId: ID!, $insertedAtSortDirection: SortDirection) {
    loanAchRequests(loanId: $loanId, insertedAtSortDirection: $insertedAtSortDirection) {
      achRequests {
        id
        achType
        amountCents
        status
        failureReason
        returnCode
        returnInitiatedAt
        returnProcessedAt
        settledAt
        insertedAt
        updatedAt
      }
    }
  }
`;

/**
 * __useGetLoanAchRequestsQuery__
 *
 * To run a query within a React component, call `useGetLoanAchRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanAchRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanAchRequestsQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      insertedAtSortDirection: // value for 'insertedAtSortDirection'
 *   },
 * });
 */
export function useGetLoanAchRequestsQuery(
  baseOptions: Apollo.QueryHookOptions<GetLoanAchRequestsQuery, GetLoanAchRequestsQueryVariables> &
    ({ variables: GetLoanAchRequestsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLoanAchRequestsQuery, GetLoanAchRequestsQueryVariables>(
    GetLoanAchRequestsDocument,
    options,
  );
}
export function useGetLoanAchRequestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLoanAchRequestsQuery, GetLoanAchRequestsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLoanAchRequestsQuery, GetLoanAchRequestsQueryVariables>(
    GetLoanAchRequestsDocument,
    options,
  );
}
// @ts-ignore
export function useGetLoanAchRequestsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetLoanAchRequestsQuery, GetLoanAchRequestsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanAchRequestsQuery, GetLoanAchRequestsQueryVariables>;
export function useGetLoanAchRequestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLoanAchRequestsQuery, GetLoanAchRequestsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanAchRequestsQuery | undefined, GetLoanAchRequestsQueryVariables>;
export function useGetLoanAchRequestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLoanAchRequestsQuery, GetLoanAchRequestsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLoanAchRequestsQuery, GetLoanAchRequestsQueryVariables>(
    GetLoanAchRequestsDocument,
    options,
  );
}
export type GetLoanAchRequestsQueryHookResult = ReturnType<typeof useGetLoanAchRequestsQuery>;
export type GetLoanAchRequestsLazyQueryHookResult = ReturnType<typeof useGetLoanAchRequestsLazyQuery>;
export type GetLoanAchRequestsSuspenseQueryHookResult = ReturnType<typeof useGetLoanAchRequestsSuspenseQuery>;
export type GetLoanAchRequestsQueryResult = Apollo.QueryResult<
  GetLoanAchRequestsQuery,
  GetLoanAchRequestsQueryVariables
>;
export const GetUserByIdDocument = /*#__PURE__*/ gql`
  query getUserById($userId: String!) {
    listUsers(idSearch: $userId, resultsPerPage: 20, pageNumber: 1) {
      users {
        id
        firstName
        middleName
        lastName
        email
        phone
        dob
        isFriendsAndFam
        insertedAt
        cards {
          id
          status
          referenceId
          active
          lastFour
          expDate
          physicalActivatedAt
          blockedReason
          dateOpened
          insertedAt
        }
        loans {
          id
          partnerAccountNumber
          status
          isDelinquent
          program {
            id
            name
          }
        }
        billingAddress {
          id
          addressFirstLine
          addressSecondLine
          city
          state
          zip
          isPoBox
        }
        shippingAddress {
          id
          addressFirstLine
          addressSecondLine
          city
          state
          zip
          isPoBox
        }
      }
    }
  }
`;

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a React component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables> &
    ({ variables: GetUserByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
}
export function useGetUserByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
}
// @ts-ignore
export function useGetUserByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export function useGetUserByIdSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUserByIdQuery | undefined, GetUserByIdQueryVariables>;
export function useGetUserByIdSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
}
export type GetUserByIdQueryHookResult = ReturnType<typeof useGetUserByIdQuery>;
export type GetUserByIdLazyQueryHookResult = ReturnType<typeof useGetUserByIdLazyQuery>;
export type GetUserByIdSuspenseQueryHookResult = ReturnType<typeof useGetUserByIdSuspenseQuery>;
export type GetUserByIdQueryResult = Apollo.QueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const GetLoanStatementsDocument = /*#__PURE__*/ gql`
  query getLoanStatements($loanId: ID!) {
    loanStatements(loanId: $loanId) {
      id
      billingPeriodStart
      billingPeriodEnd
      dueDate
      previousBalance
      totalPayments
      otherCredits
      totalPurchases
      cashAdvance
      interestCharged
      feesCharged
      newBalance
      creditLimit
      creditLimitAvailable
      minimumPaymentDue
      ytdFeesCharged
      ytdInterestCharged
      closingBalance
      interestApplied
      lateFeeApplied
      hasPdf
      purchaseBalanceAtPeriodEnd
      drawdownBalanceAtPeriodEnd
      interestBalanceAtPeriodEnd
      feeBalanceAtPeriodEnd
      repaymentBalanceAtPeriodEnd
      averageDailyBalance
      graceSavings
      newPurchaseBalanceAtPeriodEnd
      statementDate
      graceActive
      previousBalancePaidInFull
      loan {
        id
        partnerAccountNumber
      }
      lateFeeEligibleOn
      dueDateProcessedAt
      lateFeeProcessedAt
      autopayProcessedAt
      pdfGeneratedAt
      insertedAt
      updatedAt
    }
  }
`;

/**
 * __useGetLoanStatementsQuery__
 *
 * To run a query within a React component, call `useGetLoanStatementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanStatementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanStatementsQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useGetLoanStatementsQuery(
  baseOptions: Apollo.QueryHookOptions<GetLoanStatementsQuery, GetLoanStatementsQueryVariables> &
    ({ variables: GetLoanStatementsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLoanStatementsQuery, GetLoanStatementsQueryVariables>(GetLoanStatementsDocument, options);
}
export function useGetLoanStatementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLoanStatementsQuery, GetLoanStatementsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLoanStatementsQuery, GetLoanStatementsQueryVariables>(
    GetLoanStatementsDocument,
    options,
  );
}
// @ts-ignore
export function useGetLoanStatementsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetLoanStatementsQuery, GetLoanStatementsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanStatementsQuery, GetLoanStatementsQueryVariables>;
export function useGetLoanStatementsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLoanStatementsQuery, GetLoanStatementsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanStatementsQuery | undefined, GetLoanStatementsQueryVariables>;
export function useGetLoanStatementsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLoanStatementsQuery, GetLoanStatementsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLoanStatementsQuery, GetLoanStatementsQueryVariables>(
    GetLoanStatementsDocument,
    options,
  );
}
export type GetLoanStatementsQueryHookResult = ReturnType<typeof useGetLoanStatementsQuery>;
export type GetLoanStatementsLazyQueryHookResult = ReturnType<typeof useGetLoanStatementsLazyQuery>;
export type GetLoanStatementsSuspenseQueryHookResult = ReturnType<typeof useGetLoanStatementsSuspenseQuery>;
export type GetLoanStatementsQueryResult = Apollo.QueryResult<GetLoanStatementsQuery, GetLoanStatementsQueryVariables>;
export const GetLoanTransactionsDocument = /*#__PURE__*/ gql`
  query getLoanTransactions(
    $loanId: ID!
    $from: Date
    $to: Date
    $sortDirection: SortDirection
    $viewMode: TransactionViewMode
  ) {
    loanTransactions(loanId: $loanId, from: $from, to: $to, sortDirection: $sortDirection, viewMode: $viewMode) {
      transactions {
        id
        amount
        effectiveDate
        transmissionDate
        transactionType
        direction
        status
        merchantDetails {
          name
          displayName
          city
          region
        }
      }
    }
  }
`;

/**
 * __useGetLoanTransactionsQuery__
 *
 * To run a query within a React component, call `useGetLoanTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanTransactionsQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      sortDirection: // value for 'sortDirection'
 *      viewMode: // value for 'viewMode'
 *   },
 * });
 */
export function useGetLoanTransactionsQuery(
  baseOptions: Apollo.QueryHookOptions<GetLoanTransactionsQuery, GetLoanTransactionsQueryVariables> &
    ({ variables: GetLoanTransactionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLoanTransactionsQuery, GetLoanTransactionsQueryVariables>(
    GetLoanTransactionsDocument,
    options,
  );
}
export function useGetLoanTransactionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLoanTransactionsQuery, GetLoanTransactionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLoanTransactionsQuery, GetLoanTransactionsQueryVariables>(
    GetLoanTransactionsDocument,
    options,
  );
}
// @ts-ignore
export function useGetLoanTransactionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetLoanTransactionsQuery, GetLoanTransactionsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanTransactionsQuery, GetLoanTransactionsQueryVariables>;
export function useGetLoanTransactionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLoanTransactionsQuery, GetLoanTransactionsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanTransactionsQuery | undefined, GetLoanTransactionsQueryVariables>;
export function useGetLoanTransactionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLoanTransactionsQuery, GetLoanTransactionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLoanTransactionsQuery, GetLoanTransactionsQueryVariables>(
    GetLoanTransactionsDocument,
    options,
  );
}
export type GetLoanTransactionsQueryHookResult = ReturnType<typeof useGetLoanTransactionsQuery>;
export type GetLoanTransactionsLazyQueryHookResult = ReturnType<typeof useGetLoanTransactionsLazyQuery>;
export type GetLoanTransactionsSuspenseQueryHookResult = ReturnType<typeof useGetLoanTransactionsSuspenseQuery>;
export type GetLoanTransactionsQueryResult = Apollo.QueryResult<
  GetLoanTransactionsQuery,
  GetLoanTransactionsQueryVariables
>;
export const ListCardsDocument = /*#__PURE__*/ gql`
  query listCards(
    $idSortDirection: SortDirection
    $idSearch: String
    $insertedAtSortDirection: SortDirection
    $statusSortDirection: SortDirection
    $statusSelections: [CardStatus]
    $referenceIdSortDirection: SortDirection
    $referenceIdSearch: String
    $active: Boolean
    $userFirstNameSortDirection: SortDirection
    $userFirstNameSearch: String
    $userLastNameSortDirection: SortDirection
    $userLastNameSearch: String
    $userEmailSortDirection: SortDirection
    $userEmailSearch: String
    $userIsFriendsAndFam: Boolean
    $paginationDetailsOnly: Boolean
    $to: Date
    $from: Date
    $resultsPerPage: Int
    $pageNumber: Int
    $programId: ID
  ) {
    listCards(
      idSortDirection: $idSortDirection
      idSearch: $idSearch
      insertedAtSortDirection: $insertedAtSortDirection
      statusSortDirection: $statusSortDirection
      statusSelections: $statusSelections
      referenceIdSortDirection: $referenceIdSortDirection
      referenceIdSearch: $referenceIdSearch
      active: $active
      userFirstNameSortDirection: $userFirstNameSortDirection
      userFirstNameSearch: $userFirstNameSearch
      userLastNameSortDirection: $userLastNameSortDirection
      userLastNameSearch: $userLastNameSearch
      userEmailSortDirection: $userEmailSortDirection
      userEmailSearch: $userEmailSearch
      userIsFriendsAndFam: $userIsFriendsAndFam
      paginationDetailsOnly: $paginationDetailsOnly
      to: $to
      from: $from
      resultsPerPage: $resultsPerPage
      pageNumber: $pageNumber
      programId: $programId
    ) {
      cards {
        id
        status
        referenceId
        active
        lastFour
        expDate
        physicalActivatedAt
        blockedReason
        dateOpened
        insertedAt
        user {
          id
          firstName
          lastName
          isFriendsAndFam
        }
        loan {
          id
          program {
            id
            name
          }
        }
      }
      pagination {
        totalRecords
        resultsPerPage
        pageNumber
        hasNextPage
        totalPages
      }
    }
  }
`;

/**
 * __useListCardsQuery__
 *
 * To run a query within a React component, call `useListCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCardsQuery({
 *   variables: {
 *      idSortDirection: // value for 'idSortDirection'
 *      idSearch: // value for 'idSearch'
 *      insertedAtSortDirection: // value for 'insertedAtSortDirection'
 *      statusSortDirection: // value for 'statusSortDirection'
 *      statusSelections: // value for 'statusSelections'
 *      referenceIdSortDirection: // value for 'referenceIdSortDirection'
 *      referenceIdSearch: // value for 'referenceIdSearch'
 *      active: // value for 'active'
 *      userFirstNameSortDirection: // value for 'userFirstNameSortDirection'
 *      userFirstNameSearch: // value for 'userFirstNameSearch'
 *      userLastNameSortDirection: // value for 'userLastNameSortDirection'
 *      userLastNameSearch: // value for 'userLastNameSearch'
 *      userEmailSortDirection: // value for 'userEmailSortDirection'
 *      userEmailSearch: // value for 'userEmailSearch'
 *      userIsFriendsAndFam: // value for 'userIsFriendsAndFam'
 *      paginationDetailsOnly: // value for 'paginationDetailsOnly'
 *      to: // value for 'to'
 *      from: // value for 'from'
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNumber: // value for 'pageNumber'
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useListCardsQuery(baseOptions?: Apollo.QueryHookOptions<ListCardsQuery, ListCardsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListCardsQuery, ListCardsQueryVariables>(ListCardsDocument, options);
}
export function useListCardsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListCardsQuery, ListCardsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListCardsQuery, ListCardsQueryVariables>(ListCardsDocument, options);
}
// @ts-ignore
export function useListCardsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListCardsQuery, ListCardsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListCardsQuery, ListCardsQueryVariables>;
export function useListCardsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCardsQuery, ListCardsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListCardsQuery | undefined, ListCardsQueryVariables>;
export function useListCardsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCardsQuery, ListCardsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListCardsQuery, ListCardsQueryVariables>(ListCardsDocument, options);
}
export type ListCardsQueryHookResult = ReturnType<typeof useListCardsQuery>;
export type ListCardsLazyQueryHookResult = ReturnType<typeof useListCardsLazyQuery>;
export type ListCardsSuspenseQueryHookResult = ReturnType<typeof useListCardsSuspenseQuery>;
export type ListCardsQueryResult = Apollo.QueryResult<ListCardsQuery, ListCardsQueryVariables>;
export const ListDevicesDocument = /*#__PURE__*/ gql`
  query listDevices(
    $insertedAtSortDirection: SortDirection
    $userIdSortDirection: SortDirection
    $userIdSearch: String
    $userFirstNameSortDirection: SortDirection
    $userFirstNameSearch: String
    $userLastNameSortDirection: SortDirection
    $userLastNameSearch: String
    $userEmailSortDirection: SortDirection
    $userEmailSearch: String
    $deviceTypeSortDirection: SortDirection
    $deviceTypeSelections: [DeviceType]
    $paginationDetailsOnly: Boolean
    $resultsPerPage: Int
    $pageNumber: Int
    $programId: ID
  ) {
    listDevices(
      insertedAtSortDirection: $insertedAtSortDirection
      userIdSortDirection: $userIdSortDirection
      userIdSearch: $userIdSearch
      userFirstNameSortDirection: $userFirstNameSortDirection
      userFirstNameSearch: $userFirstNameSearch
      userLastNameSortDirection: $userLastNameSortDirection
      userLastNameSearch: $userLastNameSearch
      userEmailSortDirection: $userEmailSortDirection
      userEmailSearch: $userEmailSearch
      deviceTypeSortDirection: $deviceTypeSortDirection
      deviceTypeSelections: $deviceTypeSelections
      paginationDetailsOnly: $paginationDetailsOnly
      resultsPerPage: $resultsPerPage
      pageNumber: $pageNumber
      programId: $programId
    ) {
      devices {
        id
        userId
        deviceType
        deviceModel
        osVersion
        appVersion
        lastUsedAt
        createdAt
        deletedAt
        user {
          id
          loans {
            id
            program {
              id
              name
            }
          }
        }
      }
      pagination {
        totalRecords
        resultsPerPage
        pageNumber
        hasNextPage
        totalPages
      }
    }
  }
`;

/**
 * __useListDevicesQuery__
 *
 * To run a query within a React component, call `useListDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDevicesQuery({
 *   variables: {
 *      insertedAtSortDirection: // value for 'insertedAtSortDirection'
 *      userIdSortDirection: // value for 'userIdSortDirection'
 *      userIdSearch: // value for 'userIdSearch'
 *      userFirstNameSortDirection: // value for 'userFirstNameSortDirection'
 *      userFirstNameSearch: // value for 'userFirstNameSearch'
 *      userLastNameSortDirection: // value for 'userLastNameSortDirection'
 *      userLastNameSearch: // value for 'userLastNameSearch'
 *      userEmailSortDirection: // value for 'userEmailSortDirection'
 *      userEmailSearch: // value for 'userEmailSearch'
 *      deviceTypeSortDirection: // value for 'deviceTypeSortDirection'
 *      deviceTypeSelections: // value for 'deviceTypeSelections'
 *      paginationDetailsOnly: // value for 'paginationDetailsOnly'
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNumber: // value for 'pageNumber'
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useListDevicesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListDevicesQuery, ListDevicesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListDevicesQuery, ListDevicesQueryVariables>(ListDevicesDocument, options);
}
export function useListDevicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListDevicesQuery, ListDevicesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListDevicesQuery, ListDevicesQueryVariables>(ListDevicesDocument, options);
}
// @ts-ignore
export function useListDevicesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListDevicesQuery, ListDevicesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListDevicesQuery, ListDevicesQueryVariables>;
export function useListDevicesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDevicesQuery, ListDevicesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListDevicesQuery | undefined, ListDevicesQueryVariables>;
export function useListDevicesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDevicesQuery, ListDevicesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListDevicesQuery, ListDevicesQueryVariables>(ListDevicesDocument, options);
}
export type ListDevicesQueryHookResult = ReturnType<typeof useListDevicesQuery>;
export type ListDevicesLazyQueryHookResult = ReturnType<typeof useListDevicesLazyQuery>;
export type ListDevicesSuspenseQueryHookResult = ReturnType<typeof useListDevicesSuspenseQuery>;
export type ListDevicesQueryResult = Apollo.QueryResult<ListDevicesQuery, ListDevicesQueryVariables>;
export const ListLoansDocument = /*#__PURE__*/ gql`
  query listLoans(
    $idSortDirection: SortDirection
    $idSearch: String
    $partnerAccountNumberSortDirection: SortDirection
    $partnerAccountNumberSearch: String
    $hasPromo: Boolean
    $statusSortDirection: SortDirection
    $statusSelections: [LoanStatus]
    $borrowerSortDirection: SortDirection
    $closedAtSortDirection: SortDirection
    $dateOfLastActivitySortDirection: SortDirection
    $originationDateSortDirection: SortDirection
    $paginationDetailsOnly: Boolean
    $from: Date
    $to: Date
    $resultsPerPage: Int
    $pageNumber: Int
    $programId: ID
  ) {
    listLoans(
      idSortDirection: $idSortDirection
      idSearch: $idSearch
      partnerAccountNumberSortDirection: $partnerAccountNumberSortDirection
      partnerAccountNumberSearch: $partnerAccountNumberSearch
      hasPromo: $hasPromo
      statusSortDirection: $statusSortDirection
      statusSelections: $statusSelections
      borrowerSortDirection: $borrowerSortDirection
      closedAtSortDirection: $closedAtSortDirection
      dateOfLastActivitySortDirection: $dateOfLastActivitySortDirection
      originationDateSortDirection: $originationDateSortDirection
      paginationDetailsOnly: $paginationDetailsOnly
      from: $from
      to: $to
      resultsPerPage: $resultsPerPage
      pageNumber: $pageNumber
      programId: $programId
    ) {
      loans {
        id
        partnerAccountNumber
        propertyState
        status
        creditLimit
        aprMargin
        isDelinquent
        closedAt
        dateOfLastActivity
        originationDate
        users {
          id
          firstName
          lastName
        }
        program {
          id
          name
        }
      }
      pagination {
        totalRecords
        resultsPerPage
        pageNumber
        hasNextPage
        totalPages
      }
    }
  }
`;

/**
 * __useListLoansQuery__
 *
 * To run a query within a React component, call `useListLoansQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLoansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLoansQuery({
 *   variables: {
 *      idSortDirection: // value for 'idSortDirection'
 *      idSearch: // value for 'idSearch'
 *      partnerAccountNumberSortDirection: // value for 'partnerAccountNumberSortDirection'
 *      partnerAccountNumberSearch: // value for 'partnerAccountNumberSearch'
 *      hasPromo: // value for 'hasPromo'
 *      statusSortDirection: // value for 'statusSortDirection'
 *      statusSelections: // value for 'statusSelections'
 *      borrowerSortDirection: // value for 'borrowerSortDirection'
 *      closedAtSortDirection: // value for 'closedAtSortDirection'
 *      dateOfLastActivitySortDirection: // value for 'dateOfLastActivitySortDirection'
 *      originationDateSortDirection: // value for 'originationDateSortDirection'
 *      paginationDetailsOnly: // value for 'paginationDetailsOnly'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNumber: // value for 'pageNumber'
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useListLoansQuery(baseOptions?: Apollo.QueryHookOptions<ListLoansQuery, ListLoansQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListLoansQuery, ListLoansQueryVariables>(ListLoansDocument, options);
}
export function useListLoansLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListLoansQuery, ListLoansQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListLoansQuery, ListLoansQueryVariables>(ListLoansDocument, options);
}
// @ts-ignore
export function useListLoansSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListLoansQuery, ListLoansQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListLoansQuery, ListLoansQueryVariables>;
export function useListLoansSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLoansQuery, ListLoansQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListLoansQuery | undefined, ListLoansQueryVariables>;
export function useListLoansSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLoansQuery, ListLoansQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListLoansQuery, ListLoansQueryVariables>(ListLoansDocument, options);
}
export type ListLoansQueryHookResult = ReturnType<typeof useListLoansQuery>;
export type ListLoansLazyQueryHookResult = ReturnType<typeof useListLoansLazyQuery>;
export type ListLoansSuspenseQueryHookResult = ReturnType<typeof useListLoansSuspenseQuery>;
export type ListLoansQueryResult = Apollo.QueryResult<ListLoansQuery, ListLoansQueryVariables>;
export const ListUsersDocument = /*#__PURE__*/ gql`
  query listUsers(
    $idSortDirection: SortDirection
    $idSearch: String
    $firstNameSortDirection: SortDirection
    $firstNameSearch: String
    $lastNameSortDirection: SortDirection
    $lastNameSearch: String
    $phoneSortDirection: SortDirection
    $phoneSearch: String
    $dobSortDirection: SortDirection
    $dobSearch: String
    $isFriendsAndFam: Boolean
    $insertedAtSortDirection: SortDirection
    $from: Date
    $to: Date
    $paginationDetailsOnly: Boolean
    $resultsPerPage: Int
    $pageNumber: Int
    $programId: ID
  ) {
    listUsers(
      idSortDirection: $idSortDirection
      idSearch: $idSearch
      firstNameSortDirection: $firstNameSortDirection
      firstNameSearch: $firstNameSearch
      lastNameSortDirection: $lastNameSortDirection
      lastNameSearch: $lastNameSearch
      phoneSortDirection: $phoneSortDirection
      phoneSearch: $phoneSearch
      dobSortDirection: $dobSortDirection
      dobSearch: $dobSearch
      isFriendsAndFam: $isFriendsAndFam
      insertedAtSortDirection: $insertedAtSortDirection
      from: $from
      to: $to
      paginationDetailsOnly: $paginationDetailsOnly
      resultsPerPage: $resultsPerPage
      pageNumber: $pageNumber
      programId: $programId
    ) {
      users {
        id
        firstName
        lastName
        email
        phone
        dob
        isFriendsAndFam
        insertedAt
        loans {
          id
          program {
            id
            name
          }
        }
      }
      pagination {
        totalRecords
        resultsPerPage
        pageNumber
        hasNextPage
        totalPages
      }
    }
  }
`;

/**
 * __useListUsersQuery__
 *
 * To run a query within a React component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersQuery({
 *   variables: {
 *      idSortDirection: // value for 'idSortDirection'
 *      idSearch: // value for 'idSearch'
 *      firstNameSortDirection: // value for 'firstNameSortDirection'
 *      firstNameSearch: // value for 'firstNameSearch'
 *      lastNameSortDirection: // value for 'lastNameSortDirection'
 *      lastNameSearch: // value for 'lastNameSearch'
 *      phoneSortDirection: // value for 'phoneSortDirection'
 *      phoneSearch: // value for 'phoneSearch'
 *      dobSortDirection: // value for 'dobSortDirection'
 *      dobSearch: // value for 'dobSearch'
 *      isFriendsAndFam: // value for 'isFriendsAndFam'
 *      insertedAtSortDirection: // value for 'insertedAtSortDirection'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      paginationDetailsOnly: // value for 'paginationDetailsOnly'
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNumber: // value for 'pageNumber'
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useListUsersQuery(baseOptions?: Apollo.QueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
}
export function useListUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
}
// @ts-ignore
export function useListUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListUsersQuery, ListUsersQueryVariables>;
export function useListUsersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListUsersQuery | undefined, ListUsersQueryVariables>;
export function useListUsersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
}
export type ListUsersQueryHookResult = ReturnType<typeof useListUsersQuery>;
export type ListUsersLazyQueryHookResult = ReturnType<typeof useListUsersLazyQuery>;
export type ListUsersSuspenseQueryHookResult = ReturnType<typeof useListUsersSuspenseQuery>;
export type ListUsersQueryResult = Apollo.QueryResult<ListUsersQuery, ListUsersQueryVariables>;
export const LoansWithoutServicingDataDocument = /*#__PURE__*/ gql`
  query loansWithoutServicingData {
    loansWithoutServicingData {
      id
      partnerAccountNumber
      originationDate
      status
      members {
        userId
        firstName
        lastName
        joinedAt
      }
    }
  }
`;

/**
 * __useLoansWithoutServicingDataQuery__
 *
 * To run a query within a React component, call `useLoansWithoutServicingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoansWithoutServicingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoansWithoutServicingDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoansWithoutServicingDataQuery(
  baseOptions?: Apollo.QueryHookOptions<LoansWithoutServicingDataQuery, LoansWithoutServicingDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LoansWithoutServicingDataQuery, LoansWithoutServicingDataQueryVariables>(
    LoansWithoutServicingDataDocument,
    options,
  );
}
export function useLoansWithoutServicingDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LoansWithoutServicingDataQuery, LoansWithoutServicingDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LoansWithoutServicingDataQuery, LoansWithoutServicingDataQueryVariables>(
    LoansWithoutServicingDataDocument,
    options,
  );
}
// @ts-ignore
export function useLoansWithoutServicingDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoansWithoutServicingDataQuery,
    LoansWithoutServicingDataQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<LoansWithoutServicingDataQuery, LoansWithoutServicingDataQueryVariables>;
export function useLoansWithoutServicingDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LoansWithoutServicingDataQuery, LoansWithoutServicingDataQueryVariables>,
): Apollo.UseSuspenseQueryResult<LoansWithoutServicingDataQuery | undefined, LoansWithoutServicingDataQueryVariables>;
export function useLoansWithoutServicingDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LoansWithoutServicingDataQuery, LoansWithoutServicingDataQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LoansWithoutServicingDataQuery, LoansWithoutServicingDataQueryVariables>(
    LoansWithoutServicingDataDocument,
    options,
  );
}
export type LoansWithoutServicingDataQueryHookResult = ReturnType<typeof useLoansWithoutServicingDataQuery>;
export type LoansWithoutServicingDataLazyQueryHookResult = ReturnType<typeof useLoansWithoutServicingDataLazyQuery>;
export type LoansWithoutServicingDataSuspenseQueryHookResult = ReturnType<
  typeof useLoansWithoutServicingDataSuspenseQuery
>;
export type LoansWithoutServicingDataQueryResult = Apollo.QueryResult<
  LoansWithoutServicingDataQuery,
  LoansWithoutServicingDataQueryVariables
>;
export const ProgramsDocument = /*#__PURE__*/ gql`
  query programs {
    programs {
      id
      name
    }
  }
`;

/**
 * __useProgramsQuery__
 *
 * To run a query within a React component, call `useProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProgramsQuery(baseOptions?: Apollo.QueryHookOptions<ProgramsQuery, ProgramsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProgramsQuery, ProgramsQueryVariables>(ProgramsDocument, options);
}
export function useProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramsQuery, ProgramsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ProgramsQuery, ProgramsQueryVariables>(ProgramsDocument, options);
}
// @ts-ignore
export function useProgramsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ProgramsQuery, ProgramsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ProgramsQuery, ProgramsQueryVariables>;
export function useProgramsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramsQuery, ProgramsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ProgramsQuery | undefined, ProgramsQueryVariables>;
export function useProgramsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramsQuery, ProgramsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ProgramsQuery, ProgramsQueryVariables>(ProgramsDocument, options);
}
export type ProgramsQueryHookResult = ReturnType<typeof useProgramsQuery>;
export type ProgramsLazyQueryHookResult = ReturnType<typeof useProgramsLazyQuery>;
export type ProgramsSuspenseQueryHookResult = ReturnType<typeof useProgramsSuspenseQuery>;
export type ProgramsQueryResult = Apollo.QueryResult<ProgramsQuery, ProgramsQueryVariables>;
